import React, { Component } from "react";
import axios from "axios";
import { Image, Form } from "react-bootstrap";
import classnames from "classnames";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { PopupActionButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import {
  NewInputText,
  SelectBoxCategoryMui,
} from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import { serverApi, imageUploadSize } from "../../../../../config/Keys";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { MobileNumberValidation } from "../../../../../store/validation/allValidationFile/authenticationValidation/MobileNumberValidation";
import SimpleReactLightbox from "simple-react-lightbox";
import Alert from "react-s-alert";
import SingleImageReusableComponent from "../../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import {
  superadmin_referrals_add,
  superadmin_refrees_change_status,
  superadmin_refrees_get,
} from "../../../../../store/actions/SuperAdminActions/superadminreferralsaction";
import moment from "moment";

class AddReferreePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      referralName: "",
      referralEmail: "",
      country_code: "",
      mobile_number: "",
      fromdate: "",
      fromtime: "",
      todate: "",
      totime: "",
      allcategory: [
        { id: 1, category_name: "Sales" },
        { id: 2, category_name: "Affiliates" },
        { id: 3, category_name: "Partners" },
        { id: 4, category_name: "marketing" },
        // { id: 3, category_name: "Vendor" },
        // { id: 3, category_name: "User" },
      ],
      category: "",
      allpositions : [
        { id: 1, category_name: "Sales Intern" },
        { id: 2, category_name: " Sales Associate" },
        { id: 3, category_name: "Sales Supervisor " },
        { id: 4, category_name: "Sales Manager" },
        { id: 5, category_name: "ASM" },
        { id: 6, category_name: " RSM" },
      ],
      addIcon: "",
      errors: [],
      logo_url: "",
      logo_main: null,
    };
  }

  componentDidMount() {
    if (this.props.withIcon) {
      this.setState({
        referralName: this.props.data.name,
        referralEmail: this.props.data.email,
        country_code: this.props.data.country_code,
        mobile_number: this.props.data.mobile_number,
        category: this.props.data.role,
        logo_url: this.props.data.profile_photo
          ? this.props.data.profile_photo
          : "",
      });
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (nextProps.show) {
      this.onOpenModal();
    }
    if (nextProps.withIcon) {
      this.setState({
        referralName: nextProps.data.name,
        referralEmail: nextProps.data.email,
        country_code: nextProps.data.country_code,
        mobile_number: nextProps.data.mobile_number,
        category: nextProps.data.role,
        logo_url: nextProps.data.profile_photo
          ? nextProps.data.profile_photo
          : "",
      });
    }
    return null;
  }

  onChange = (e) => {
    // this.props.clear_all_errors();
    const { value } = e.target;
    this.setState({
      [e.target.name]: value,
      errors: {},
    });
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
    if (this.props.setShow) {
      this.props.setShow(0);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { errors } = this.state;
    this.setState({
      errors: {},
    });

    if (!this.state.referralName) {
      this.setState({
        errors: { ...errors, referralName: "Please fill the name" },
      });
    } else if (!this.state.country_code) {
      this.setState({
        errors: { ...errors, country_code: "Please fill this field" },
      });
    } else if (!this.state.mobile_number) {
      this.setState({
        errors: { ...errors, mobile_number: "Please fill this field" },
      });
    } else if (!this.state.logo_url) {
      this.setState({
        errors: { ...errors, logo_url: "Please Upload an image" },
      });
    } else if (!this.state.fromdate) {
      this.setState({
        errors: { ...errors, fromdate: "Please fill this field" },
      });
    } else if (!this.state.fromtime) {
      this.setState({
        errors: { ...errors, fromtime: "Please fill this field" },
      });
    } else if (!this.state.todate) {
      this.setState({
        errors: { ...errors, todate: "Please fill this field" },
      });
    } else if (!this.state.totime) {
      this.setState({
        errors: { ...errors, totime: "Please fill this field" },
      });
    } else if (!this.state.category) {
      this.setState({
        errors: { ...errors, category: "Please select this field" },
      });
    } else {
      const token = this.props.auth.user.accessToken;
      if (this.props.withIcon) {
        const formData = {
          name: this.state.referralName,
          active: this.props.data.active,
          // email: this.state.referralEmail,
          // country_code: this.state.country_code,
          // mobile_number: this.state.mobile_number,
          role: this.state.category,
          profile_photo: this.state.logo_url,
        };

        this.props.superadmin_refrees_change_status(
          token,
          this.props.data._id,
          formData,
          () => {
            this.onCloseModal();
            this.props.superadmin_refrees_get(token);
            Alert.success(`<h4>Refree edited successfully.</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          }
        );
      } else if (
        !moment(this.state.todate).isSameOrAfter(this.state.fromdate, "day")
      ) {
        this.setState({
          errors: { ...errors, todate: "Please select a correct date" },
        });
      } else {
        const formData = {
          name: this.state.referralName,
          email: this.state.referralEmail,
          country_code: this.state.country_code,
          mobile_number: this.state.mobile_number,
          role: this.state.category,
          profile_photo: this.state.logo_url,
          active_from: new Date(
            this.state.fromdate + " " + this.state.fromtime
          ).valueOf(),
          expire_at: new Date(
            this.state.todate + " " + this.state.totime
          ).valueOf(),
        };

        this.props.superadmin_referrals_add(formData, token, () => {
          this.onCloseModal();
          this.props.superadmin_refrees_get(token);
          Alert.success(`<h4>Refree added successfully.</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
      }
    }
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    this.setState({
      logo_url: url,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };

  onImageLogoUploadHandler = (e) => {
    try {
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        this.setState({
          logo_main: e.target.files[0],
          combined: "",
        });
      }
      e.target.value = "";
    } catch (err) {
      console.log(err);
    }
  };

  removeFile = () => {
    console.log(this.state.logo_url);
    let restaurantLogo = this.state.logo_url;
    restaurantLogo = "";
    this.setState({
      logo_url: restaurantLogo,
      actionButton: true,
    });
  };

  render() {
    const { open, errors } = this.state;
    return (
      <div>
        {this.props.withIcon ? (
          <div className="super-admin-icon-box-width">
            <Image
              src={
                !this.props.src
                  ? require("../../../../../assets/images/OfferAndEventImages/edit.png")
                  : require("../../../../../assets/images/OfferAndEventImages/view.png")
              }
              alt="View Icon"
              title="View Profile"
              fluid
              onClick={this.onOpenModal}
            />
          </div>
        ) : (
          <button
            onClick={this.onOpenModal}
            className="btn add_button_custom_1"
          >
            + Add Referee
          </button>
        )}

        {/* <IconButtonReusableComponent
          buttonText="Add Referree"
          onClick={this.onOpenModal}
          buttonType="button"
        /> */}
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "add-icon-main-popup",
            closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
            zIndex: "zIndex-1060",
          }}
          animationDuration={1000}
        >
          <div className="top-headerbar">
            <h3>{this.props.withIcon ? "Edit" : "Add"} Referree</h3>
            <Image
              fluid
              src={require("../../../../../assets/images/AuthImages/menu.png")}
              onClick={this.onCloseModal}
              alt="Remove Icon"
            />
          </div>
          <div className="icon-add-body-section">
            <Form noValidate onSubmit={this.handleSubmit}>
              <NewInputText
                displayLabel={true}
                controlId="referralName"
                labelText="Name"
                inputType="text"
                placeHolder="Ram Kumar Sharma"
                name="referralName"
                onChange={
                  // this.onChange
                  (e) => {
                    console.log(e.target.value);
                    this.setState({ referralName: e.target.value });
                  }
                }
                value={this.state.referralName}
                required="required"
                showBottom={true}
                errorTrue={errors.referralName}
                inputClassName={classnames("input-component-inputfield", {
                  invalid: errors.referralName,
                })}
              />
              <NewInputText
                displayLabel={true}
                controlId="referralEmail"
                labelText="Email"
                inputType="email"
                name="email"
                onChange={(e) => {
                  this.setState({ referralEmail: e.target.value });
                }}
                value={this.state.referralEmail}
                required="required"
                showBottom={true}
                errorTrue={errors.referralEmail}
                inputClassName={classnames("input-component-inputfield", {
                  invalid: errors.referralEmail,
                })}
              />
              <Form.Row className="input-component-insideRow mb-3">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                  <Form.Group
                    className="reusableInputComponent-main mb-0"
                    controlId={"country_code"}
                  >
                    <Form.Label className="d-flex input-component-labeltext  mt-3">
                      Phone Number
                    </Form.Label>
                    <div className="input-phone-country-code-reusable">
                      <select
                        name="country_code"
                        value={this.state.country_code}
                        onChange={(e) => {
                          this.setState({ country_code: e.target.value });
                        }}
                      >
                        <option value={this.state.country_code}>
                          {this.state.country_code}
                        </option>
                        {getCountries().map((country) => (
                          <option
                            key={country}
                            value={"+" + getCountryCallingCode(country)}
                          >
                            {en[country]} (+{getCountryCallingCode(country)})
                          </option>
                        ))}
                      </select>
                    </div>
                  </Form.Group>
                </div>
                <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0 mt-5">
                  <NewInputText
                    displayLabel={"displayLabelNone"}
                    controlId="mobile_number"
                    labelText="Mobile Number"
                    inputType="number"
                    placeHolder="Enter mobile number"
                    name="mobile_number"
                    onChange={(e) => {
                      this.setState({ mobile_number: e.target.value });
                    }}
                    value={this.state.mobile_number}
                    required="required"
                    showBottom={true}
                    errorTrue={errors.mobile_number}
                    inputClassName={classnames(
                      "input-component-inputfield input-field-referrals-code-margin",
                      {
                        invalid: errors.mobile_number,
                      }
                    )}
                  /> 
                </div>
              </Form.Row>
              <SelectBoxCategoryMui
                controlId={"category"}
                getData={this.state.allcategory.map(
                  (data) => data.category_name
                )}
                inputlabelclass="input-component-labeltext"
                selectLabel="Select Role"
                name="category"
                value={this.state.category}
                onChange={(e) => {
                  console.log(e.target.value);
                  this.setState({ category: e.target.value });
                }}
                errorTrue={errors.category}
                inputClass={classnames("input-component-inputfield w-100", {
                  invalid: errors.category,
                })}
              />
              {!this.props.withIcon && (
                <div className="row">
                  <div className="col-12">
                    <div className="f12-500">Validity </div>
                  </div>
                  <div className="col-6 mt-3">
                    <NewInputText
                      displayLabel={true}
                      controlId="fromdate"
                      labelText="From date"
                      inputType="date"
                      placeHolder=""
                      name="fromdate"
                      onChange={this.onChange}
                      value={this.state.fromdate}
                      required="required"
                      showBottom={true}
                      errorTrue={errors.fromdate}
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.fromdate,
                      })}
                    />
                  </div>
                  <div className="col-6 mt-3">
                    <NewInputText
                      displayLabel={true}
                      controlId="fromtime"
                      labelText="From Time"
                      inputType="time"
                      placeHolder=""
                      name="fromtime"
                      onChange={this.onChange}
                      value={this.state.fromtime}
                      required="required"
                      showBottom={true}
                      errorTrue={errors.fromtime}
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.fromtime,
                      })}
                    />
                  </div>
                  <div className="col-6 mt-3">
                    <NewInputText
                      displayLabel={true}
                      controlId="todate"
                      labelText="To Date"
                      inputType="date"
                      placeHolder=""
                      name="todate"
                      onChange={this.onChange}
                      value={this.state.todate}
                      required="required"
                      showBottom={true}
                      errorTrue={errors.todate}
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.todate,
                      })}
                    />
                  </div>
                  <div className="col-6 mt-3">
                    <NewInputText
                      displayLabel={true}
                      controlId="totime"
                      labelText="To Time"
                      inputType="time"
                      placeHolder=""
                      name="totime"
                      onChange={this.onChange}
                      value={this.state.totime}
                      required="required"
                      showBottom={true}
                      errorTrue={errors.totime}
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.totime,
                      })}
                    />
                  </div>
                </div>
              )}
              <SimpleReactLightbox>
                <SingleImageReusableComponent
                  title="Add Logo*"
                  // smallTitle="( You can upload only 1 pic per offer 700 x 420 pixels )"
                  // onDrop={this.onSingleImageDrop}
                  onChange={this.onImageLogoUploadHandler}
                  combined={this.state.combined && this.state.combined}
                  onCompleteCrop={this.onCompleteCrop}
                  onCancelCrop={this.onCancelCrop}
                  file={
                    (this.state.logo_main &&
                      this.state.logo_main !== null &&
                      this.state.logo_main) ||
                    (this.state.logo_url && this.state.logo_url)
                  }
                  resetFile={this.removeFile}
                  name="logo_url"
                  errorTrue={errors.logo_url}
                  // loader={this.state.singleImageLoader}
                />
                <div className="font_12_r c_gray mb-4 mt-3">
                  Only .jpg and .png files. 500kb max file size
                </div>
              </SimpleReactLightbox>
              {/* <div>
                <div className="file_upload_superadmin mt-3">
                  <div className="file-lable-text">
                    <label>Profile Image</label>
                  </div>
                  <div className="view_chainsBor restaurant_details_onboarding_file_upload mt-0">
                    <div className="custom_file_upload list_icon_custom_file_upload ">
                      <input
                        type="file"
                        name="icon"
                        id="file"
                        onChange={this.onImageLogoUploadHandler}
                        className="custom_input_upload"
                      />
                      <label
                        className="custom_input_label newChain_add"
                        htmlFor="file"
                      >
                        <div>
                          <i
                            className="fa fa-plus"
                            style={{ color: "#CCCCCC" }}
                          ></i>
                        </div>
                        <div className="add_new_text"></div>
                      </label>
                    </div>

                    <div className="newChain_addthree">
                      {/* mx-3 
                      {this.state.addIcon ? (
                        <img
                          src={this.state.addIcon}
                          className="newChain_addtwo"
                          // style={{ height: "100%", width: "100%" }}
                          alt="chain"
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="row justify-content-end position-relative">
                <div className="col-12 bottom-button d-flex justify-content-between mt-4 add-diner-floating-button">
                  <div className="margin-seating-left">
                    <PopupActionButton
                      buttonText="Cancel"
                      buttonType="button"
                      buttonClass="bigbuttongray"
                      onClick={this.onCloseModal}
                    />
                  </div>
                  <PopupActionButton
                    buttonText="Save"
                    buttonType="Submit"
                    buttonClass="bigbuttonred"
                  />
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

AddReferreePopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_referrals_add,
  superadmin_refrees_change_status,
  superadmin_refrees_get,
})(withRouter(AddReferreePopup));
